
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import InnerBanner from '../components/PagesComponents/InnerBanner';
import React, { useEffect, useState } from 'react';
import AdminEditTestimonialForm from '../components/AdminComponents/AdminEditTestimonialForm';
const AdminEditTestimonial = () => {
 return (
    <>
    <InnerBanner pageKey="adminTestimonialEdit" />
      <section className='profile-sec py-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-9'>
                     <AdminEditTestimonialForm/>
                </div>
                <div className='col-lg-3'>
                    <DashboardSidebar/>
                </div>
            </div>
        </div>
      </section>
    </>
 );

};

export default AdminEditTestimonial;
